export enum MedicalHistoryStatus {    
    Unknown = -1,
    No = 0,
    Yes = 1,
    TreatedInPast = 2,
    StillBeingTreated = 3
}